import React from 'react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: SelectOption[];
  error?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
}

const Select: React.FC<SelectProps> = ({ 
  options,
  error, 
  fullWidth = true, 
  className = '', 
  placeholder,
  ...props 
}) => {
  const baseClasses = 'px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors bg-white';
  const widthClasses = fullWidth ? 'w-full' : '';
  const errorClasses = error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300';
  const rtlClasses = 'text-right pl-8 pr-3';
  
  // Custom styles to completely hide default arrow
  const selectStyle = {
    appearance: 'none' as const,
    WebkitAppearance: 'none' as const,
    MozAppearance: 'none' as const,
    backgroundImage: 'none'
  };
  
  return (
    <div className="relative">
      <select
        className={`${baseClasses} ${widthClasses} ${errorClasses} ${rtlClasses} ${className}`}
        style={selectStyle}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {/* Custom dropdown arrow positioned on the left for RTL */}
      <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default Select; 